import React from 'react';
import { injectIntl } from 'react-intl';
import s from './ContactPage.module.scss';
import Header from '../LegacyContactPage/Header';
import SmallFooter from '../../common/SmallFooter/SmallFooter';
import OfferGenerationWizardContainer from './OfferGenerationWizardContainer';
import Intro from './Intro';

const FOOTER_LINKS = [
  {
    targets: {
      de: 'https://vision.verbund.com/data-protection?locale=de',
      en: 'https://vision.verbund.com/data-protection?locale=en',
    },
    i18n: 'contactpage.dataProtection',
  },
  {
    targets: {
      de: 'https://www.verbund.com/de-at/nutzungsbedingungen',
      en: 'https://www.verbund.com/en-at/terms-of-use',
    },
    i18n: 'contactpage.termsOfUse',
  },
  {
    targets: {
      de: '/kontakt/imprint',
      en: '/kontakt/imprint',
    },
    i18n: 'contactpage.imprintDisclosure',
  },
];

function ContactPage() {
  return (
    <div className={s.pageWrapper}>
      <div className={`${s.page}`}>
        {/* todo: see if we can really reuse this header */}
        <Header />
        <Intro />
        <OfferGenerationWizardContainer />
        <footer className={s.footers}>
          <SmallFooter links={FOOTER_LINKS} />
        </footer>
      </div>
    </div>
  );
}

export default injectIntl(ContactPage);
